<template>
  <transition name="slide">
    <div class="row h-100 mt-5 text-center">

      <div  class="col-md-6 col-xl-4 mx-auto">
         <div>
          <img src="@/assets/img/logo.png" height="80" class="mb-3" />
        </div>

        <div class="form-side">
          <form-base
            title=""
            action="Login"
            :errors="errors"
            :loading="loading"
            :btnBlock="true"
            @handleSubmit="handleSubmit"
          >
            <template v-slot:header>
              <h3>Login</h3>
            </template>

            <template v-slot:fields>
              <label class="form-group has-float-label mb-4">
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': $v.email.$error }"
                  ref="email"
                  v-model="email"
                />
                <span>Email</span>
                <div class="invalid-feedback" v-if="!$v.email.required">
                  Please enter email address
                </div>
                <div class="invalid-feedback" v-if="!$v.email.email">
                  invalid email address
                </div>
              </label>

              <label class="form-group has-float-label mb-4">
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': $v.password.$error }"
                  v-model="password"
                />
                <span>Password</span>
                <div class="invalid-feedback" v-if="!$v.email.required">
                  Please enter password
                </div>
              </label>

              

            </template>

            <template v-slot:buttons>
              <div class="mt-3"></div>
              <div class="form-group">
                 <b-form-checkbox
                    v-model="remember"
                    value="1"
                  >
                    Remember Me
                  </b-form-checkbox>
              </div>
            </template>
          </form-base>
        </div>

         <div class="mt-4">
            <router-link :to="{name:'forgot-password'}" class="text-primary">
              i've forgotten my password
            </router-link>
          </div>

        <b-modal ref="error-modal" title="Error">
          Whoops! Something went wrong!
        </b-modal>
      </div>
    </div>
  </transition>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import formBase from '@/components/common/FormBase'

export default {
  components: {
    formBase
  },
  mounted () {
    this.$refs.email.focus()
  },
  data () {
    return {
      email: '',
      password: '',
      remember: '0',
      loading: false,
      errors: []
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },

  methods: {
    ...mapActions('user', ['doCheckAuth']),

    async handleSubmit () {
      this.loading = true

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.loading = false
      } else {
        try {
          await this.doCheckAuth({
            email: this.email,
            password: this.password,
            remember:this.remember
          })

          if (this.$route.params.nextUrl != null) {
            this.$router.push(this.$route.params.nextUrl)
          } else {
            this.$router.push({ name: 'dashboard' })
          }
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = [];
            this.errors.push('Invalid Credentials')
            this.email = this.password = ''
            this.$refs.email.focus()
          } else {
            this.$refs['error-modal'].show()
          }
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
